import script from "./seroi-svc-wait.vue?vue&type=script&setup=true&lang=js"
export * from "./seroi-svc-wait.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__